import React from 'react'
import SuccessStoriesPage from '../parts/pages/SuccessStoriesPage'

export default function SuccessStories() {
  return <SuccessStoriesPage />
}
